<template>
  <menu-content-container
    v-if="isInEuro && selectedItem"
    :header="$t('product.currency_settings')"
    :padding-left-right="8"
  >
    <content-row>
      <TDropdown
        :data="eurOptions"
        :selected="selectedShape.value"
        class="!w-[70px]"
        @selection-changed="handleSelectShape"
      >
      </TDropdown>
      <TSwitch
        v-if="selectedShape.value === '€'"
        v-model="selectedPosition"
        label="5€"
        left-label="€5"
      ></TSwitch>
    </content-row>
  </menu-content-container>
</template>

<script lang="ts" setup>
  import { useMjmlStore } from "@/stores/mjmlStore";
  import formatPrice from "@/utils/formatPrice";
  import { TDropdown, TSwitch } from "@topol/twig-ui";
  import { computed } from "vue";

  const props = defineProps<{
    selectedItem: any;
    block: any;
    layout: {
      type: any;
      displayed: any;
      uid: string;
    }[];
  }>();

  const eurShapes = ["EUR", "€"];

  const eurOptions = [
    { value: "€", label: "€" },
    { value: "EUR", label: "EUR" },
  ];
  const mjmlStore = useMjmlStore();

  const isInEuro = computed(() => {
    if (!props.selectedItem) return false;
    return eurShapes.includes(props.selectedItem.currency);
  });

  const shape = computed({
    get() {
      return mjmlStore.getActiveBlockAttrString("eur-shape");
    },
    set(val: string) {
      mjmlStore.updateBlockAttribute({
        prop: "eur-shape",
        value: val,
        product: true,
      });
    },
  });

  const selectedShape = computed({
    get() {
      return shape.value === "EUR" ? { value: "EUR" } : { value: "€" };
    },
    set(val: { value: string }) {
      shape.value = val.value;
      formatPrices();
    },
  });

  const position = computed({
    get() {
      return mjmlStore.getActiveBlockAttrString("eur-position");
    },
    set(val: string) {
      mjmlStore.updateBlockAttribute({
        prop: "eur-position",
        value: val,
        product: true,
      });
    },
  });

  const selectedPosition = computed({
    get() {
      return position.value !== "prefix";
    },
    set(val: boolean) {
      const newPosition = val ? "suffix" : "prefix";
      position.value = newPosition;
      formatPrices();
    },
  });

  function formatPrices() {
    props.layout.forEach((item) => {
      let name = item.type;
      let key = name;
      if (name === "priceBefore") {
        name = "price-before";
        key = "price_before";
      } else if (name === "price") {
        key = "price_vat";
      }
      if (name.includes("price") && props.selectedItem[key]) {
        mjmlStore.updateBlockAttribute({
          prop: name,
          value: formatPrice(
            props.selectedItem[key],
            props.selectedItem.currency,
            shape.value,
            position.value
          ),
          product: true,
        });
      }
    });
  }

  function handleSelectShape(option: any) {
    selectedShape.value = option;
  }
</script>
